export function generateFileNameAppendix(
  extension: string = 'xlsx',
): string {
  const offsetMinutes = Number(localStorage.getItem('tz') ?? 0);
  const local = new Date(Date.now() + offsetMinutes * 60000); //new Date() creates date based of miliseconds
  const formattedDate = local.toISOString().replace(/[:T]/g, '-').split('.')[0];
  return `_${formattedDate}.${extension}`;
}
